export enum Role{
    SuperAdmin = "SuperAdmin",
    Admin = "Admin",
    Clinician = "Clinician",
    Parent = "Parent",
    Teacher = "Teacher",
    Respondent = "Respondent"
}